export function form() {
  //個人情報チェック
  const formPrivacyArr = document.querySelectorAll('.js-formPrivacy');
  for (let index = 0; index < formPrivacyArr.length; index++) {
    let formPrivacy = formPrivacyArr[index];
    let trigger = formPrivacy.querySelector('.js-formPrivacy--trigger');
    let submit = formPrivacy.querySelector('.js-formPrivacy--submit');
    trigger.addEventListener('change', () => {
      if(trigger.checked) { //チェックした場合
        submit.disabled = false;
      } else {
        submit.disabled = true;
      }
    })
  }
}